import { ContentDiscoveryMenuItemType } from '@/enums';
import { getErrorMessage } from '@/store/services/validationService';
import { LogicJump } from '..';
import { MenuBase } from './menuBase';

export interface IChannelMenu {
    logicJump?: LogicJump;
}

export class ChannelMenu extends MenuBase implements IChannelMenu {
    menuType: ContentDiscoveryMenuItemType;

    logicJump?: LogicJump;

    constructor() {
        super();
        this.menuType = ContentDiscoveryMenuItemType.Channel;
    }

    async validate(): Promise<any> {
        let errors = await super.validate();
        const logicJumpErrors = await this.logicJump?.validate();
        if (Object.keys(logicJumpErrors).length) {
            errors = errors || {};
            errors.logicJump = [getErrorMessage('logicJumpContent', 'channel')];
        }
        return errors;
    }
}
